<ng-container *ngIf="userVM">
  <div class="action-buttons">
    <ichannel-button
      [callback]="userVM.resetChanges.bind(userVM)"
      [label]="'Reset Changes'"
    ></ichannel-button>
    <ichannel-button
      *ngIf="userVM.showResetPasswordButton"
      [callback]="userVM.resetPassword.bind(userVM)"
      [label]="'Reset Password'"
      [theme]="'DARK'"
    ></ichannel-button>
    <ichannel-button
      *ngIf="userVM.showReseTwoFactorButton"
      [callback]="userVM.reset2FA.bind(userVM)"
      [label]="'Reset Two Factor'"
      [theme]="'DARK'"
    ></ichannel-button>
    <ichannel-button
      (click)="userVM.applyChanges()"
      [label]="'SAVE'"
      [theme]="'DARK'"
    ></ichannel-button>
  </div>
  <div class="tabs-menu">
    <div
      (click)="userVM.choosenTab = 'personal'"
      [ngClass]="{ selected: userVM.choosenTab === 'personal' }"
    >
      Personal Details
    </div>
    <div
      (click)="userVM.choosenTab = 'channel-permission'"
      [ngClass]="{ selected: userVM.choosenTab === 'channel-permission' }"
      (click)="userVM.initChannelPermissions().then()"
    >
      Channel Permissions
    </div>
    <div
      (click)="userVM.choosenTab = 'action-permission'"
      [ngClass]="{ selected: userVM.choosenTab === 'action-permission' }"
    >
      Action Permissions
    </div>
  </div>
  <div [ngSwitch]="userVM.choosenTab" class="user-form">
    <evrideo-user-channel-permissions
      [userVM]="userVM"
      *ngSwitchCase="'channel-permission'"
    ></evrideo-user-channel-permissions>
    <evrideo-user-action-permissions
      [userVM]="userVM"
      *ngSwitchCase="'action-permission'"
    ></evrideo-user-action-permissions>
    <evrideo-user-personal-info
      [userVM]="userVM"
      *ngSwitchDefault
    ></evrideo-user-personal-info>
  </div>
</ng-container>
